import { GET_TERRITORIES_LIST, SET_TERRITORIES_LIST } from './constants';

const initialState = {
  territoriesList: [],
};

const eRecognitionReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_TERRITORIES_LIST:
      state = {
        ...state,
        territoriesList: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default eRecognitionReducers;
